import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class PrioritizeCompletingLineupsAboveExp extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.do('prioritizeCompletingLineupsAboveExp', isChecked));
    }

    render() {
        const {lineupsFilter} = this.props;
        const isChecked = lineupsFilter.prioritizeCompletingLineupsAboveExp;

        return (
            <div>
                <InputCheckbox
                    label="Prioritize completing lineups above min/max exposure settings"
                    checked={isChecked}
                    onChange={::this.onChange}
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {filters: lineupsFilter} = state.lineupsData;

    return {
        lineupsFilter,
    };
}

export default connect(mapStatesToProps)(PrioritizeCompletingLineupsAboveExp);
